import styled from "styled-components";

export const SortByLists = styled.ul`
  padding: 0;
  margin: 0 2rem 0 0;
  list-style-type: none;
  display: flex;
  align-items: center;
`;

export const SortByItem = styled.li`
  margin-left: 2rem;
  transition: .3s;

  &:not(.active-sort), a{
    color: var(--gray-color);
    cursor: pointer;
    
    &:hover, a:hover {
      color: #627187;
    }
  }
  
  &.active-sort, &.active-sort a {
    color: var(--accent-success-color);
    pointer-events: none;
  }
  
  @media (max-width: 1240px) and (min-width: 992px) {
     a {
      font-size: .8rem;
    }
  }

  @media (max-width: 1100px) and (min-width: 992px) {
    margin-left: 1rem;
  }
  
`;

export const SortTitle = styled.p`
  @media (max-width: 1100px) and (min-width: 992px) {
    font-size: .9rem;
  }
`;
